import { defineMessages } from 'react-intl';

export default defineMessages({

    qty: {
        id: 'formsOrdering.component.forms-list.QTY',
        defaultMessage: 'QTY'
    },
    category:{
        id: "formsOrdering.component.forms-list.CATEGORY",
        defaultMessage: "CATEGORY" 
    },
    formNo: {
        id: "formsOrdering.component.forms-list.FORM NO.",
        defaultMessage: "FORM NO." 
    },
    state: {
        id: 'formsOrdering.component.forms-list.STATE',
        defaultMessage: 'STATE'
    },    
    forms: {
        id: "formsOrdering.component.forms-list.Forms",
        defaultMessage: "Forms"
    }
    
});
